import { render, staticRenderFns } from "./CartItems.vue?vue&type=template&id=35fe268d&scoped=true&"
import script from "./CartItems.vue?vue&type=script&lang=js&"
export * from "./CartItems.vue?vue&type=script&lang=js&"
import style0 from "./CartItems.vue?vue&type=style&index=0&id=35fe268d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe268d",
  null
  
)

export default component.exports